import { useContext } from "react"

import { useSnackbar } from "notistack"
import RegistradorContext from "../../../../contexts/registradorContext"
import ServicosContext from "../../../../contexts/servicosContext"
import Cabecalho from "../../../Cabecalho"

import Button from "@material-ui/core/Button"
import TextField from "@material-ui/core/TextField"
import { Col, Row } from "react-bootstrap"
// import REGISTRADOR_ICON from '../../../../assets/icons/svg/049-circulation.svg';

import { listarClientes, RegistrarLogErro } from "../../../../services/clientefiel"

import { Dialog, IconButton } from "@material-ui/core"
import { Close } from "@material-ui/icons"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min"
import useAppStore from "../../../../stores/AppStore"

export default function Index({ iframe }) {
    const autorizacao = localStorage.getItem("chaveSistema")
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
    const history = useHistory()
    const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))

    const { handlePedidoDeMesa } = useContext(ServicosContext)

    const {
        carrinho,
        setCarrinho,
        setOpenListaClientes,
        setLoadingClientes,
        setListaClientes,
        setOpenCadastroCliente,
        setOpenListaEnderecos,
        setOpenGerenciarMesa,
        setListaMesas,
        handleToggleParteInicial,
        openParteInicial,
        estabelecimentosDisponiveis,

        setCliente,
    } = useContext(RegistradorContext)

    const { enqueueSnackbar } = useSnackbar()

    const configuracoes = useAppStore(s => s.configuracoes)

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    // const handleOpenGerenciamentoMesa = async () => {
    //     try {
    //         setOpenGerenciarMesa(true)

    //         const retorno = await BuscarMesas(autorizacao)
    //         if (retorno.retornoErro) {
    //             alertStart(retorno.mensagem, "error")
    //             return false
    //         }

    //         if (retorno.length === 0) {
    //             setListaMesas([{ naoTem: true }])
    //         } else {
    //             setListaMesas(retorno)
    //         }
    //     } catch (error) {
    //         RegistrarLogErro(error, "handleOpenGerenciamentoMesa")
    //         alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
    //     }
    // }

    const handleBuscarClientes = async e => {
        const valorDigitado = document.getElementById("procurar-cliente")?.value

        const textoLimpo = valorDigitado?.replace(/[^a-zA-Z0-9]/g, "")
        const numero = textoLimpo && /^\d+$/.test(textoLimpo)

        let buscar = null
        if (numero) {
            buscar = textoLimpo
        } else {
            buscar = valorDigitado
        }

        try {
            console.log("||> handleBuscarClientes", e)
            e.preventDefault()
            const nomePesquisa = buscar
            setOpenListaClientes(true)
            setLoadingClientes(true)
            const data = {
                idEstabelecimento: configuracoes.user.parametros.estabelecimento.id,
                nomeCliente: nomePesquisa,
                maxResultado: 100,
                token: "a~I?;;+_@!AL^",
            }
            const response = await listarClientes(autorizacao, data)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            setListaClientes(response)
            setLoadingClientes(false)
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarClientes")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    return (
        <Dialog
            open={openParteInicial}
            onClose={handleToggleParteInicial}
            fullScreen={estabelecimentosDisponiveis.length > 1 || mobile ? true : false}
            style={{
                zInde: 2,
                paddingLeft: mobile || iframe ? "" : "80px",
            }}
        >
            {(estabelecimentosDisponiveis.length > 1 || mobile) && !iframe && (
                <Cabecalho pagina={"Registrador de Pedidos"} />
            )}
            {estabelecimentosDisponiveis.length === 1 && (
                <IconButton
                    aria-label="close"
                    onClick={handleToggleParteInicial}
                    style={{
                        position: "absolute",
                        right: "8px",
                        top: "10px",
                        zIndex: 3,
                        cursor: "pointer",
                    }}
                >
                    <Close />
                </IconButton>
            )}
            <form
                onSubmit={handleBuscarClientes}
                style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "2em",
                    height: "100%",

                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Row className="container-registrador">
                    <Col
                        xs={12}
                        md={12}
                        lg={12}
                        style={{ marginBottom: "10px", textAlign: "center", margin: "auto" }}
                    >
                        <img
                            src={
                                configuracoes.user?.parametros.estabelecimento?.urlLogo
                                    ? configuracoes.user?.parametros.estabelecimento?.urlLogo
                                    : aplicativoDados.urlLogo
                            }
                            style={{
                                height: "150px",
                                marginBottom: "2em",
                                opacity: "0.8",
                                borderRadius: "1em",
                            }}
                            alt=""
                        />
                    </Col>
                    <Col xs={12} md={12} lg={12} style={{ textAlign: "center", zIndex: 99 }}>
                        <TextField
                            id="procurar-cliente"
                            fullWidth
                            label="Procurar Cliente (Nome ou Telefone)"
                            variant="outlined"
                            style={{ background: "#fff", zIndex: 2 }}
                        />
                    </Col>

                    <Col xs={12} lg={12}>
                        <Button
                            fullWidth
                            className="mt-4"
                            onClick={handleBuscarClientes}
                            variant="contained"
                            style={{ backgroundColor: "#007BFF", color: "white" }}
                        >
                            Buscar Cliente
                        </Button>
                    </Col>
                    <Col xs={12} lg={4}>
                        <Button
                            fullWidth
                            onClick={() => setOpenCadastroCliente(true)}
                            className="mt-4"
                            variant="contained"
                            style={{ backgroundColor: "#28A745", color: "white" }}
                        >
                            Cadastrar Cliente
                        </Button>
                    </Col>

                    <Col xs={12} lg={4}>
                        <Button
                            fullWidth
                            onClick={() => {
                                setCliente(true)
                                carrinho.cliente = {}
                                setOpenListaEnderecos(true)
                            }}
                            className="mt-4"
                            variant="contained"
                            style={{ backgroundColor: "#6C757D", color: "white" }}
                        >
                            Pedido Anônimo
                        </Button>
                    </Col>
                    <Col xs={12} lg={4}>
                        <Button
                            fullWidth
                            onClick={handlePedidoDeMesa}
                            className="mt-4"
                            variant="contained"
                            style={{ backgroundColor: "#FFC107", color: "white" }}
                        >
                            Gerenciar Mesas
                        </Button>
                    </Col>
                </Row>
            </form>
        </Dialog>
    )
}
